import DtcEditComponent from '../../../../components/dtcs/TATMappings/DtcEdit'

const DtcEdit = () => {
  return <DtcEditComponent />
}

export default DtcEdit
